import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faAngleDown,
  faAngleLeft,
  faBan,
  faCaretDown,
  faCheck,
  faDownload,
  faExclamationTriangle,
  faExternalLinkAlt,
  faInfoCircle,
  faMoneyBillAlt,
  faPlusCircle,
  faPencilAlt,
  faQuestionCircle,
  faShoppingCart,
  faTimes,
  faTrashAlt,
  faUndo,
  faUpload
} from '@fortawesome/free-solid-svg-icons'
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons'
import { faLine, faTwitter, faXTwitter } from '@fortawesome/free-brands-svg-icons'

library.add(
  faAngleDown,
  faAngleLeft,
  faBan,
  faCaretDown,
  faCheck,
  faCheckCircle,
  faDownload,
  faExclamationTriangle,
  faExternalLinkAlt,
  faInfoCircle,
  faMoneyBillAlt,
  faPencilAlt,
  faPlusCircle,
  faQuestionCircle,
  faShoppingCart,
  faTimes,
  faTrashAlt,
  faUndo,
  faUpload,
  faLine,
  faTwitter,
  faXTwitter
)

export const component = {
  'font-awesome-icon': FontAwesomeIcon
}
